// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueResource from 'vue-resource';
import VueCookie from 'vue-cookie';
import Auth from './packages/auth/Auth.js';
import AppSettings from './packages/settings/Settings';
import Audience from "./packages/audience/Audience";
import Notification from 'vue-notification';
Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(VueCookie);
Vue.use(Notification);
Vue.use(Auth);
Vue.use(AppSettings);
Vue.use(Audience);

router.beforeEach(
  (to, from, next) => {
    if (to.matched.some(record => record.meta.forVisitors)) {
      if (Vue.auth.isAuthenticated()) {
        next({
          path: '/home'
        })
      } else next()
    } else next()

    if (to.matched.some(record => record.meta.forAuth)) {
      if (!Vue.auth.isAuthenticated()) {
        next({
          path: '/login'
        })
      } else next()
    }
  }
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js